export default __webpack_public_path__ + "static/media/fireIcon.a9e704c7.svg";